<div class="tab-sustainable">
    <div class="row">
        <!-- image -->
        <div class="col-sm-6 pr-xl-0 left mt-sm-0 mt-3 order-sm-1 order-2">
            <div class="thumbnail" [ngStyle]="{'background-image' : 'url('+ apiAsset + curData?.picture +')'}">
                <div class="detail-thumb" 
                    *ngIf="curData?.content" 
                    [innerHTML]="curData?.content"></div>
            </div>
            <div class="warp-icons d-sm-none d-flex justify-content-between">
                <div class="symbol text-center" *ngFor="let data of dataTabSustain; let i = index">
                    <div class="icon-sus" 
                        [ngClass]="{'active': i === 0}" 
                        (click)="changeOverview(data, $event)">
                        <img class="w-100" [src]="apiAsset + data.icon" [alt]="">
                    </div>
                    <span>{{ data.title }}</span>
                </div>
            </div>
        </div>
        <!-- detail -->
        <div class="col-sm-6 right mt-sm-0 mt-4 order-sm-2 order-1">
            <div class="position-relative h-100">
                <div class="detail">
                    <div class="border-bot">
                        <p class="cat text-uppercase">{{ isLang?.sustainability }} </p>
                    </div>
                    <h6 class="title my-3">{{ curData?.section.title }}</h6>
                    <div class="sum" [innerHTML]="curDataDesc"></div>
                    <div class="link pt-1">
                        <a routerLink="/sustainability/{{ curData?.title_en | lowercase}}" class="link-more">
                            {{ isLang?.learnMore }} 
                            <span class="pl-1 icon">
                                <i class="icon ion-ios-arrow-round-forward"></i>
                            </span>
                        </a>
                    </div>
                </div>
                <div class="warp-icons d-sm-flex d-none justify-content-between">
                    <div class="symbol text-center" *ngFor="let data of dataTabSustain; let i = index">
                        <div class="icon-sus" 
                            [ngClass]="{'active': i === 0}" 
                            (click)="changeOverview(data, $event)">
                            <img class="w-100" [src]="apiAsset + data.icon" [alt]="">
                        </div>
                        <span>{{ data.title }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

